module.exports = __webpack_public_path__ + "static/step-1.010d73e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/quickstart/layout/step-1.png
// module id = 2566
// module chunks = 255491318291911